<template>
  <v-layout
    class="white"
    align-space-between
    justify-start
    column
    fill-height
  >
    <v-flex
      shrink
      class="sz_background_light"
      py-3
    >
      <v-flex
        md10
        offset-md1
        sm12
        offset-sm0
      >
        <v-layout
          class="header none-growth"
          align-center
        >
          <v-flex shrink>
            <AppLogo width="60" />
          </v-flex>
          <v-flex ml-5>
            <h1 class="display-4">
              {{ $t('gift_giving_report.page_title') }}
            </h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
    <v-flex>
      <v-layout v-if="isLoadingFinished && showContent">
        <v-flex
          id="sheet-container"
          md10
          offset-md1
          sm12
          offset-sm0
        >
          <v-layout
            :mt-5="$vuetify.breakpoint.smAndUp"
            class="stepper__wrapper"
            mb-0
            fill-height
          >
            <v-flex
              v-if="$vuetify.breakpoint.smAndUp"
              pa-4
              sm3
              class="stepper__header"
            >
              <TableOfContent :TOCData="TOC">
                <template slot="backButton">
                  <a
                    class="link_iconed"
                    @click="moveToCard()"
                  >
                    <v-icon>keyboard_arrow_left</v-icon>
                    {{ $t('buttons.return_to_family_card') }}</a>
                </template>
              </TableOfContent>
            </v-flex>
            <v-dialog
              v-else
              v-model="contentDialog"
              hide-overlay
              persistent
              scrollable
              fullscreen
            >
              <v-layout
                style="background: #fff; overflow: scroll"
                fill-height
              >
                <TableOfContent
                  :TOCData="TOC"
                  @closeDialog="contentDialog = false"
                >
                  <template slot="backButton">
                    <a
                      class="link_iconed"
                      @click="moveToCard()"
                    >
                      <v-icon>keyboard_arrow_left</v-icon>
                      {{ $t('buttons.return_to_family_card') }}</a>
                  </template>
                </TableOfContent>
              </v-layout>
            </v-dialog>
            <v-flex
              px-4
              pt-4
              pb-0
              xs12
              sm9
              :class="isCurrentEdition ? 'white' : 'deprecated deprecated_background'"
            >
              <v-layout
                v-if="$vuetify.breakpoint.xsOnly"
                align-center
                justify-space-between
                class="pb-3"
              >
                <v-flex>
                  <a
                    class="link_iconed"
                    @click="goToFamilyCard"
                  >
                    <v-icon>keyboard_arrow_left</v-icon> {{ $t('sheet.cancel_button') }}</a>
                </v-flex>
                <v-flex shrink>
                  <a @click="contentDialog = true">
                    <BaseIcon>
                      <MenuIcon />
                    </BaseIcon>
                  </a>
                </v-flex>
              </v-layout>
              <v-flex
                v-if="showContent"
                :class="[{ 'mt-3': $vuetify.breakpoint.xsOnly }]"
              >
                <GiftGivingReportInstruction v-view="viewHandler" />
                <PacksAmount
                  v-view="viewHandler"
                  :read-only="readOnly"
                />
                <GiftGiverInfo
                  v-view="viewHandler"
                  :read-only="readOnly"
                />
                <FamilyReaction
                  v-view="viewHandler"
                  :read-only="readOnly"
                />
                <PacksContent
                  v-view="viewHandler"
                  :read-only="readOnly"
                />
                <WorkWithFamily
                  v-view="viewHandler"
                  :read-only="readOnly"
                />
                <GiftGivingInstruction v-view="viewHandler" />
                <familyIntroduction
                  v-view="viewHandler"
                  :hint="false"
                  :family-guide="sheetOneMeeting.familyGuide"
                  :age-resource="ageResource"
                  :relation-resource="relationResource"
                  :changed-names="changedNames.newNames"
                />
                <v-divider class="my-4" />
                <DeliveryReport
                  v-view="viewHandler"
                  :read-only="readOnly"
                />
                <FamilyWords
                  v-view="viewHandler"
                  :read-only="readOnly"
                />
                <VolunteerWords
                  v-view="viewHandler"
                  :read-only="readOnly"
                />
                <GiftGivingPreview v-view="viewHandler" />
                <v-layout
                  justify-center
                  class="mt-4"
                  wrap
                  :pb-4="$vuetify.breakpoint.xsOnly"
                >
                  <v-flex xs12>
                    <div
                      v-if="globalFormInvalid"
                      class="v-message text-xs-center mt-3 mb-0"
                    >
                      <div class="v-messages__message">
                        {{ $t('errors.form_not_valid') }}
                      </div>
                    </div>
                  </v-flex>
                  <v-flex
                    v-if="
                      (canDoGiftGivingReportAuditInArea || canDoGiftGivingReportAuditOnNational) &&
                        isCurrentEdition
                    "
                    xs12
                  >
                    <v-layout
                      :justify-space-between="$vuetify.breakpoint.smAndUp"
                      :justify-center="$vuetify.breakpoint.xsOnly"
                      :wrap="$vuetify.breakpoint.xsOnly"
                    >
                      <v-flex class="none-growth">
                        <v-btn
                          color="sz_violet"
                          class="mr-0 text-xs-center"
                          :loading="buttonLoading"
                          :disabled="buttonLoading"
                          @click="openModal()"
                        >
                          {{ $t('buttons.save_and_send_to_correction') }}
                        </v-btn>
                      </v-flex>
                      <v-flex class="none-growth">
                        <v-btn
                          color="sz_violet"
                          class="mr-0 text-xs-center"
                          :loading="toNationalLoading"
                          :disabled="toNationalLoading"
                          @click="openToNationalModal()"
                        >
                          {{ nextLevelButtonTitle }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    v-else
                    shrink
                  >
                    <v-btn
                      color="sz_violet"
                      class="text-xs-center"
                      :loading="buttonLoading"
                      :disabled="buttonLoading"
                      @click="send()"
                    >
                      {{ buttonTitle }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <FamilyAudit
                v-if="showGiftAuditCard"
                :can-add-comment="canAddGiftComment"
                :family-id="$route.params.familyId"
                :sheet-type="'gift_giving_report'"
                :comment-level="commentLevel"
                :has-permissions-to-add-comment="hasPermissionsToAddGiftComment"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <PageLoader v-else />
    </v-flex>
    <DraftButton
      v-if="canSaveGiftDraft && isCurrentEdition"
      :family-id="$route.params.familyId"
      @clearFlags="clearValidatorFlags"
    />
    <ScrollBottomButton />
    <leaveConfirmDialog ref="confirm" />
    <AppModal
      :visible="modalVisibility"
      @close="closeModal()"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('gift_giving_report.modal.title') }}
        </p>
      </template>
      <template slot="actions">
        <v-layout wrap>
          <v-flex xs12>
            <v-divider class="mb-3" />
          </v-flex>
          <v-flex xs12>
            <v-layout
              :justify-space-between="$vuetify.breakpoint.smAndUp"
              :justify-center="$vuetify.breakpoint.xsOnly"
              align-center
              :column="$vuetify.breakpoint.xsOnly"
            >
              <v-flex
                shrink
                :class="{ 'mt-3': $vuetify.breakpoint.xs }"
                order-xs2
                order-sm1
              >
                <a @click="closeModal()">{{ $t('buttons.cancel') }}</a>
              </v-flex>
              <v-flex
                shrink
                order-xs1
                order-sm2
              >
                <v-btn
                  color="sz_violet"
                  :loading="correctingLoader"
                  :disabled="correctingLoader"
                  @click="sendToCorrection()"
                >
                  {{ $t('buttons.ok') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="modalToNationalVisibility"
      @close="closeToNationalModal()"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ nextLevelModelTitle }}
        </p>
      </template>
      <template slot="actions">
        <v-layout wrap>
          <v-flex xs12>
            <v-divider class="mb-3" />
          </v-flex>
          <v-flex xs12>
            <v-layout
              :justify-space-between="$vuetify.breakpoint.smAndUp"
              :justify-center="$vuetify.breakpoint.xsOnly"
              align-center
              :column="$vuetify.breakpoint.xsOnly"
            >
              <v-flex
                shrink
                :class="{ 'mt-3': $vuetify.breakpoint.xsOnly }"
                order-xs2
                order-sm1
              >
                <a @click="closeToNationalModal()">{{ $t('buttons.cancel') }}</a>
              </v-flex>
              <v-flex
                shrink
                order-xs1
                order-sm2
              >
                <v-btn
                  color="sz_violet"
                  :loading="nextLevelLoading"
                  :disabled="nextLevelLoading"
                  @click="nextLevelActions()"
                >
                  {{ $t('buttons.confirm_send') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="sendModalVisibility"
      @close="closeSendModal()"
    >
      <template slot="title">
        <h2 class="display-3 display-3_dark text-xs-left">
          {{ $t('gift_giving_report.send_modal.title') }}
        </h2>
      </template>
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('gift_giving_report.send_modal.subtitle') }}
        </p>
      </template>
      <template slot="actions">
        <v-layout wrap>
          <v-flex xs12>
            <v-divider class="mb-3" />
          </v-flex>
          <v-flex xs12>
            <v-layout
              :justify-space-between="$vuetify.breakpoint.smAndUp"
              :justify-center="$vuetify.breakpoint.xsOnly"
              align-center
              :column="$vuetify.breakpoint.xsOnly"
            >
              <v-flex
                shrink
                :class="{ 'mt-3': $vuetify.breakpoint.xs }"
                order-xs2
                order-sm1
              >
                <a @click="closeSendModal()">{{ $t('buttons.cancel') }}</a>
              </v-flex>
              <v-flex
                shrink
                order-xs1
                order-sm2
              >
                <v-btn
                  color="sz_violet"
                  :loading="sendLoader"
                  :disabled="sendLoader"
                  @click="volunteersActions()"
                >
                  {{ $t('buttons.send') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="confirmationModalVisibility"
      persistent
      :close-button="false"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ confirmationTitle }}
        </p>
      </template>
      <template slot="actions">
        <v-layout wrap>
          <v-flex
            xs12
            class="mt-1 mb-4"
          >
            <v-layout
              justify-center
              align-center
              :wrap="$vuetify.breakpoint.xs"
            >
              <v-flex class="none-growth">
                <v-btn
                  color="sz_violet"
                  @click="closeConfirmationModal()"
                >
                  {{ $t('buttons.ok') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
  </v-layout>
</template>

<script>
import FamilyReaction from '@/components/giftGivingReport/FamilyReaction';
import GiftGiverInfo from '@/components/giftGivingReport/GiftGiverInfo';
import GiftGivingReportInstruction from '@/components/giftGivingReport/giftGivingReportStep/GiftGivingReportInstruction';
import PacksAmount from '@/components/giftGivingReport/PacksAmount';
import PacksContent from '@/components/giftGivingReport/PacksContent';
import WorkWithFamily from '@/components/giftGivingReport/WorkWithFamily';
import GiftGivingInstruction from '@/components/giftGivingReport/GiftGivingInstruction';
import AppLogo from '@/components/widgets/AppLogo';
import TableOfContent from '@/components/widgets/TableOfContent';
import BaseIcon from '@/icons/BaseIcon';
import MenuIcon from '@/icons/MenuIcon';

import familyIntroduction from '@/components/description/familyIntroduction';
import DraftButton from '@/components/giftGivingReport/DraftButton';
import DeliveryReport from '@/components/giftGivingReport/giftGivingReportStep/DeliveryReport';
import FamilyWords from '@/components/giftGivingReport/giftGivingReportStep/FamilyWords';
import GiftGivingPreview from '@/components/giftGivingReport/giftGivingReportStep/GiftGivingPreview';
import VolunteerWords from '@/components/giftGivingReport/giftGivingReportStep/VolunteerWords';
import leaveConfirmDialog from '@/components/widgets/LeaveConfirmDialog';
import TOC from '@/constants/giftGivingReport/TOC';

import scrollToTopErrorMessage from '@/mixins/scrollToTopErrorMessage';
import isFamilyChecked from '@/mixins/sheet/isFamilyChecked';
import sheetBeforeLeave from '@/mixins/sheetBeforeLeave';

import FamilyAudit from '@/components/audit/FamilyAudit';
import PageLoader from '@/components/widgets/PageLoader';
import ScrollBottomButton from '@/components/widgets/ScrollBottomButton';
import auditPermissionsAndStatuses from '@/mixins/auditPermissionsAndStatuses';
import fieldsRemover from '@/utils/fieldsRemover';
import AppModal from '@/components/widgets/AppModal.vue';

export default {
    name: 'GiftGivingReport',
    components: {
        PageLoader,
        ScrollBottomButton,
        FamilyAudit,
        GiftGivingPreview,
        familyIntroduction,
        VolunteerWords,
        FamilyWords,
        DeliveryReport,
        AppLogo,
        TableOfContent,
        BaseIcon,
        MenuIcon,
        GiftGivingReportInstruction,
        PacksAmount,
        GiftGiverInfo,
        FamilyReaction,
        PacksContent,
        WorkWithFamily,
        GiftGivingInstruction,
        leaveConfirmDialog,
        AppModal,
        DraftButton
    },
    mixins: [sheetBeforeLeave, auditPermissionsAndStatuses, scrollToTopErrorMessage, isFamilyChecked],
    beforeRouteEnter (from, to, next) {
        next((vm) => {
            vm.$store
                .dispatch('giftGivingReport/getGiftGivingReport', vm.$route.params.familyId)
                .finally(() => {
                    vm.isDataLoad = true;
                });
            const _data = {
                id: vm.$route.params.familyId,
                endpointLabel: 'family'
            };
            vm.$store
                .dispatch('family/getFamily', _data)
                .then(({ data }) => {
                    vm.$store
                        .dispatch('sheet/loadSheetOneResource', {
                            sheetId: 1,
                            editionName: data.edition.name
                        })
                        .finally(() => {
                            vm.$store.dispatch('audit/getAllAuditComments', 'gift_giving_report');
                            vm.$store.dispatch('audit/getAuditComment', {
                                params: {
                                    sheetType: 'gift_giving_report'
                                }
                            });
                            vm.$store
                                .dispatch('giftGivingReport/getSheetResource', {
                                    sheetId: 2000,
                                    editionName: data.edition.name
                                })
                                .finally(() => {
                                    vm.isLoadingResource = false;
                                    vm.isLoadSheetResource = true;
                                });
                        });
                })
                .finally(() => {
                    vm.familyDataIsLoad = true;
                });
        });
    },
    beforeRouteLeave (to, from, next) {
        this.clearData();
        next();
    },
    data () {
        return {
            TOC,
            contentDialog: false,
            isLoadingResource: true,
            isLoadingMeeting: true,
            isLoadingSheetTwo: true,
            isLoadSheetResource: false,
            buttonLoading: false,
            globalFormInvalid: false,
            isDataLoad: false,
            familyDataIsLoad: false,
            modalVisibility: false,
            correctingLoader: false,
            confirmationModalVisibility: false,
            sendModalVisibility: false,
            sendLoader: false,
            nextLevelLoading: false,
            confirmationTitle: '',
            modalToNationalVisibility: false,
            toNationalLoading: false
        };
    },
    computed: {
        isLoadingFinished () {
            return !this.isLoadingMeeting && !this.isLoadingResource && !this.isLoadingSheetTwo;
        },
        sheetOneMeeting () {
            return this.$store.getters['sheet/getMeetingFields'];
        },
        sheetOneResource () {
            return this.$store.getters['sheet/getSheetOneResource'];
        },
        ageResource () {
            return this.sheetOneResource.sheet_resource.find((el) => {
                return el.id === 1;
            }).resources;
        },
        sheetTwo () {
            return this.$store.getters['sheet/getSheetTwo'];
        },
        relationFemaleResource () {
            return this.sheetOneResource.sheet_resource.find((el) => {
                return el.id === 2;
            }).resources;
        },
        relationMaleResource () {
            return this.sheetOneResource.sheet_resource.find((el) => {
                return el.id === 3;
            }).resources;
        },
        relationResource () {
            return this.relationFemaleResource.concat(this.relationMaleResource);
        },
        changedNames () {
            return this.sheetTwo.changedNames;
        },
        getLoadGiftGivingReportData () {
            return this.$store.getters['giftGivingReport/getLoadGiftGivingReportData'];
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        readOnly () {
            return !this.activeGiftGivingReportButton || !this.isCurrentEdition || !this.isFamilyChecked;
        },
        giftGivingReportState () {
            return this.$store.getters['giftGivingReport/returnGiftGivingReportState'];
        },
        buttonTitle () {
            if (this.readOnly) {
                return this.$t('buttons.return_to_family_card');
            }
            return this.$t('buttons.add_and_send');
        },
        showContent () {
            return this.isLoadSheetResource && this.isDataLoad && this.familyDataIsLoad;
        },
        getFamily () {
            return this.$store.getters['family/getFamily'];
        },
        familyStatusId () {
            if (this.getFamily) {
                return this.getFamily.status.family_edition_status_id;
            }
            return null;
        },
        hasDraft () {
            return this.$store.getters['giftGivingReport/getHasDraft'];
        },
        nextLevelButtonTitle () {
            if (this.isFamilyVerifiedOnNationalForGift) {
                return this.$t('buttons.send_gift_giving_report');
            }
            return this.$t('buttons.add_and_send');
        },
        nextLevelModelTitle () {
            if (this.isFamilyVerifiedOnNationalForGift) {
                return this.$t('audit.send_gift_giving_report');
            }
            return this.$t('audit.send_gift_giving_report_to_national_correction');
        }
    },
    beforeCreate () {
        this.$store
            .dispatch('sheet/loadFinalSheet', {
                familyId: this.$route.params.familyId,
                sheetType: 'meeting'
            })
            .finally(() => {
                this.isLoadingMeeting = false;
            });
        this.$store
            .dispatch('sheet/loadFinalSheet', {
                familyId: this.$route.params.familyId,
                sheetType: 'needs'
            })
            .finally(() => {
                this.isLoadingSheetTwo = false;
            });
        this.$store.commit('warehouses/setCurrentSelectorName', 'instruction');
    },
    methods: {
        viewHandler (e) {
            if (e.scrollPercent < 1) {
                if (e.target.rect.top <= 350) {
                    this.$store.commit('warehouses/setCurrentSelectorName', e.target.element.id);
                }
            } else {
                if (e.percentTop <= 1) {
                    this.$store.commit('warehouses/setCurrentSelectorName', e.target.element.id);
                }
            }
        },
        moveToCard () {
            this.$router.push({ name: 'family-card', params: { id: this.$route.params.familyId } });
        },
        clearData () {
            this.$store.commit('sheet/clearSheetOne');
            this.$store.commit('sheet/clearSheetTwo');
            this.$store.commit('giftGivingReport/clearGiftGivingReportState');
            this.$store.commit('giftGivingReport/setSheetResource', null);
            this.$store.commit('giftGivingReport/setLoadGiftGivingReportData', null);
            this.$store.commit('giftGivingReport/setHasDraft', null);
            this.$store.commit('family/setFamily', null);
        },
        convertData () {
            const _data = {
                package_count: this.giftGivingReportState.packsAmount,
                photo_consent: this.giftGivingReportState.giftGiverInfo.consentForPhoto,
                family_visited: this.giftGivingReportState.giftGiverInfo.giftGiverMetFamily,
                reason_for_visit: this.giftGivingReportState.giftGiverInfo.reasonForVisit,
                gift_giver_description: this.giftGivingReportState.giftGiverInfo.describeGiftGiver,
                family_response: this.giftGivingReportState.familyReaction,
                key_needs: this.giftGivingReportState.packsContent.isPackCorrespondsToNeeds,
                key_needs_description: this.giftGivingReportState.packsContent.wasAbsent,
                quality: this.giftGivingReportState.packsContent.packQuality,
                quality_description: this.giftGivingReportState.packsContent.packQualityArguments,
                content: this.giftGivingReportState.packsContent.packItems,
                immaterial_content: this.giftGivingReportState.packsContent.wereIntangibleNeeds,
                immaterial_content_description:
          this.giftGivingReportState.packsContent.describeIntangibleNeeds,
                plan_repeated_meeting: this.giftGivingReportState.planRepeatedMeeting,
                repeated_meeting: this.giftGivingReportState.newMeetingWithFamily,
                no_repeated_meeting_reason: this.giftGivingReportState.noRepeatedMeetingReason,
                delivery_relation: this.giftGivingReportState.deliveryReport,
                family_word: this.giftGivingReportState.familyWords,
                family_word_need: this.giftGivingReportState.familyWordNeed,
                volunteer_word: this.giftGivingReportState.volunteerWords
            };
            fieldsRemover(_data);
            fieldsRemover(_data, '', _data.family_visited !== 'yes', 'reason_for_visit');
            fieldsRemover(_data, '', _data.key_needs !== 'no', 'key_needs_description');
            fieldsRemover(_data, '', _data.immaterial_content !== 'yes', 'immaterial_content_description');
            fieldsRemover(_data, '', _data.family_word_need !== 'yes', 'family_word');
            fieldsRemover(_data, '', _data.plan_repeated_meeting === 'yes', 'no_repeated_meeting_reason');
            fieldsRemover(_data, '', _data.plan_repeated_meeting === 'no', 'repeated_meeting');
            return _data;
        },
        create () {
            this.sendLoader = true;
            const _data = {
                id: this.$route.params.familyId,
                data: this.convertData()
            };
            this.$store
                .dispatch('audit/sendGiftToAreaAudit', _data)
                .then(() => {
                    if (this.hasDraft) {
                        this.$store.dispatch(
                            'giftGivingReport/removeGiftGivingReportDraft',
                            this.$route.params.familyId
                        );
                    }
                    this.clearValidatorFlags();
                    this.moveToCard();
                })
                .finally(() => {
                    this.sendLoader = false;
                    this.buttonLoading = false;
                });
        },
        sendGiftToNationalCorrectionVolunteer () {
            this.sendLoader = true;
            const _data = {
                id: this.$route.params.familyId,
                data: this.convertData()
            };
            this.$store
                .dispatch('audit/sendGiftToNationalCorrectionVolunteer', _data)
                .then(() => {
                    this.clearValidatorFlags();
                    this.moveToCard();
                })
                .finally(() => {
                    this.sendLoader = false;
                    this.buttonLoading = false;
                });
        },
        volunteersActions () {
            if (this.isFamilyCorrectingOnNationalForGift) {
                this.sendGiftToNationalCorrectionVolunteer();
            } else {
                this.create();
            }
        },
        sendToCorrectingInArea (_data) {
            this.$store
                .dispatch('audit/sendGiftToAreaCorrection', _data)
                .then(() => {
                    this.confirmationTitle = this.$t('gift_giving_report.modal.confirmation');
                    this.openConfirmationModal();
                })
                .finally(() => {
                    this.correctingLoader = false;
                    this.buttonLoading = false;
                });
        },
        sendGiftToNationalCorrection (_data) {
            this.$store
                .dispatch('audit/sendGiftToNationalCorrection', _data)
                .then(() => {
                    this.confirmationTitle = this.$t('gift_giving_report.modal.confirmation');
                    this.openConfirmationModal();
                })
                .finally(() => {
                    this.correctingLoader = false;
                    this.buttonLoading = false;
                });
        },
        sendToCorrection () {
            this.correctingLoader = true;
            const _data = {
                id: this.$route.params.familyId,
                data: this.convertData()
            };
            if (this.canDoGiftGivingReportAuditInArea) {
                this.sendToCorrectingInArea(_data);
            } else if (this.canDoGiftGivingReportAuditOnNational) {
                this.sendGiftToNationalCorrection(_data);
            }
        },
        sendGiftToNationalAudit () {
            const _data = {
                id: this.$route.params.familyId,
                data: this.convertData()
            };
            this.$store
                .dispatch('audit/sendGiftToNationalAudit', _data)
                .then(() => {
                    this.confirmationTitle = this.$t('gift_giving_report.modal.confirmation_send_to_national');
                    this.openConfirmationModal();
                })
                .finally(() => {
                    this.nextLevelLoading = false;
                });
        },
        sendGiftToGiftGiver () {
            const data = {
                id: this.$route.params.familyId,
                data: this.convertData()
            };
            this.$store
                .dispatch('audit/sendGiftToGiftGiver', data)
                .then(() => {
                    this.confirmationTitle = this.$t('audit.send_gift_giving_report_confirmation');
                    this.openConfirmationModal();
                })
                .finally(() => {
                    this.nextLevelLoading = false;
                });
        },
        nextLevelActions () {
            this.nextLevelLoading = true;
            if (this.isFamilyVerifiedOnNationalForGift) {
                this.sendGiftToGiftGiver();
            } else {
                this.sendGiftToNationalAudit();
            }
        },
        openModal () {
            this.globalFormInvalid = false;
            this.$validator.validateAll().then((valid) => {
                this.globalFormInvalid = !valid;
                if (valid) {
                    this.modalVisibility = true;
                } else {
                    this.scrollToTopErrorMessage();
                }
            });
        },
        closeModal () {
            this.modalVisibility = false;
            this.buttonLoading = false;
        },
        openSendModal () {
            this.sendModalVisibility = true;
        },
        closeSendModal () {
            this.sendModalVisibility = false;
            this.buttonLoading = false;
        },
        openConfirmationModal () {
            this.modalToNationalVisibility = false;
            this.sendModalVisibility = false;
            this.modalVisibility = false;

            this.confirmationModalVisibility = true;
        },
        closeConfirmationModal () {
            this.confirmationModalVisibility = false;
            this.closeModal();
            this.clearValidatorFlags();
            this.moveToCard();
        },
        openToNationalModal () {
            this.globalFormInvalid = false;
            this.$validator.validateAll().then((valid) => {
                this.globalFormInvalid = !valid;
                if (valid) {
                    this.modalToNationalVisibility = true;
                } else {
                    this.scrollToTopErrorMessage();
                }
            });
        },
        closeToNationalModal () {
            this.modalToNationalVisibility = false;
            this.toNationalLoading = false;
        },
        send () {
            if (this.readOnly) {
                this.moveToCard();
                return;
            }
            this.globalFormInvalid = false;
            this.$validator.validateAll().then((valid) => {
                this.globalFormInvalid = !valid;
                if (valid) {
                    this.buttonLoading = true;
                    if (this.canEditGiftGivingReport) {
                        this.openSendModal();
                    }
                } else {
                    this.scrollToTopErrorMessage();
                }
            });
        },
        clearValidatorFlags () {
            Object.keys(this.$validator.flags).forEach((x) => {
                this.$validator.flags[x].changed = false;
            });
        },
        goToFamilyCard () {
            this.$router.push({ name: 'family-card', params: { id: this.$route.params.familyId } });
        }
    }
};
</script>

<style scoped></style>
